// 导入 Vue 和 VueRouter
import Vue from "vue";
import VueRouter from "vue-router";

// 调用 Vue.use() 函数，吧 VueRouter 安装为 Vue 的插件
Vue.use(VueRouter)

import pathArr from "./pathArr";

// import MyLogin from '@/view/Login/MyLogin.vue'  //登录页

import MyHt from '@/view/Backstage/MyHt.vue'  //后台

import login from '@/view/system/Login.vue' //后台登录页面

//二级
// import MyCggl from '@/components/Ht/MyCggl.vue'




//三级
// import MyCg1 from '@/components/Ht/Cggl/MyCg1.vue'

import layout from '@/view/system/index.vue'  // 作为主界面



import MyHome from '@/components/MyHome.vue'
import MyHonor from '@/components/MyHonor.vue'

import MyCp from '@/components/MyCp.vue'
import MyGy from '@/components/MyGy.vue'


// 子组件
import MyZs1 from '@/components/Honor/MyZs1.vue'
import MyZs2 from '@/components/Honor/MyZs2.vue'
import MyZs3 from '@/components/Honor/MyZs3.vue'
import MyZs4 from '@/components/Honor/MyZs4.vue'
import MyZs5 from '@/components/Honor/MyZs5.vue'
import MyZs6 from '@/components/Honor/MyZs6.vue'
import MyZs7 from '@/components/Honor/MyZs7.vue'
import MyZs8 from '@/components/Honor/MyZs8.vue'
import newOne from '@/components/Honor/newOne.vue'
import newTwo from '@/components/Honor/newTwo.vue'
import newThree from '@/components/Honor/newThree.vue'
import newFour from '@/components/Honor/newFour.vue'
import newFive from '@/components/Honor/newFive.vue'
import newSix from '@/components/Honor/newSix.vue'
import newSeven from '@/components/Honor/newSeven.vue'
import new1 from '@/components/Honor/new1.vue'
import new2 from '@/components/Honor/new2.vue'
import new3 from '@/components/Honor/new3.vue'
import new4 from '@/components/Honor/new4.vue'
import new5 from '@/components/Honor/new5.vue'
import new6 from '@/components/Honor/new6.vue'
import new7 from '@/components/Honor/new7.vue'
import new8 from '@/components/Honor/new8.vue'

// 团队建设
import MyTeam from '@/components/MyTeam.vue'  //主页面
import Introduction from '@/components/team/Introduction.vue'
import Activity from '@/components/team/Activity.vue'
import Training from '@/components/team/Training.vue'

import MyCp1 from '@/components/Cp/MyCp1.vue' //全荤菜
import MyCp2 from '@/components/Cp/MyCp2.vue'
import MyCp3 from '@/components/Cp/MyCp3.vue'
import MyCp4 from '@/components/Cp/MyCp4.vue'
import MyCp5 from '@/components/Cp/MyCp5.vue'

import MyGy1 from '@/components/Gy/MyGy1.vue'
import MyGy2 from '@/components/Gy/MyGy2.vue'
// import MyHonor from '@/view/Honor/MyHonor.vue'
// 典型案例
import myModel from '@/components/model/index.vue'
import model from '@/components/model/model.vue'
// 酒店餐饮
import hotelDining from '@/components/hotelDining/index.vue'
import business from '@/components/hotelDining/business.vue'
import buffet from '@/components/hotelDining/buffet.vue'
// 管理体系
import management from '@/components/management/index.vue'
import sixs from '@/components/management/6s.vue'
import informatization from '@/components/management/informatization.vue'
import nutrition from '@/components/management/nutrition.vue'
import pdca from '@/components/management/pdca.vue'
import safe from '@/components/management/safe.vue'
import system from '@/components/management/system.vue'
// 重大活动
import myCase from '@/components/MyCase.vue'
import Case713 from '@/components/Case/Case713.vue'
import Case713dz from '@/components/Case/Case713dz.vue'
import CaseHT from '@/components/Case/CaseHT.vue'
import CaseSix from '@/components/Case/CaseSix.vue'
import CaseZJLY70 from '@/components/Case/CaseZJLY70.vue'
import Case38 from '@/components/Case/Case38.vue'
import CaseDIY from '@/components/Case/CaseDIY.vue'

// 后台管理
import article from '@/view/system/article.vue'
import articleWangedit from '@/view/system/articleWangedit.vue'


// 创建路由的实例对象
const routes = [
    //     // 重定向
    //     // { path: '/', component: CsHome },
    //     // // 路由规则
        { path: '/', component: MyHome },
        { path: '/home', component: MyHome },
        { 
            path: '/honor', 
            component: MyHonor,
            redirect: "/honor/myzs1",
            children: [
                {  path: '' , component: MyZs1 },
                {  path: 'myzs1' , component: MyZs1 },
                {  path: 'myzs2' , component: MyZs2 },
                {  path: 'myzs3' , component: MyZs3 },
                {  path: 'myzs4' , component: MyZs4 },
                {  path: 'myzs5' , component: MyZs5 },
                {  path: 'myzs6' , component: MyZs6 },
                {  path: 'myzs7' , component: MyZs7 },
                {  path: 'myzs8' , component: MyZs8 },
                {  path: 'newOne', component: newOne},
                {  path: 'newTwo', component: newTwo},
                {  path: 'newThree', component:newThree},
                {  path: 'newFour',  component:newFour},
                {  path: 'newFive', component:newFive},
                {  path: 'newSix', component:newSix},
                {  path: 'newSeven', component:newSeven},
                {  path: 'new1',component:new1},
                {  path: 'new2',component:new2},
                {  path: 'new3',component:new3},
                {  path: 'new4',component:new4},
                {  path: 'new5',component:new5},
                {  path: 'new6',component:new6},
                {  path: 'new7',component:new7},
                {  path: 'new8',component:new8}
            ]    
        },
        { 
            path: '/cp' , 
            component: MyCp ,
            children: [
                { path: '', component: MyCp1 },
                { path: 'mycp1' , component: MyCp1 },
                { path: 'mycp2' , component: MyCp2 },
                { path: 'mycp3' , component: MyCp3 },
                { path: 'mycp4' , component: MyCp4 },
                { path: 'mycp5' , component: MyCp5 },
            ]
        
        },
        {
            path:'/hotelDining',
            component:hotelDining,
            children:[
                {path:'',component:business},
                {path:'/business',component:business},
                {path:'/buffet',component:buffet},
            ]
        },
        {
            path:'/myModel',
            component:myModel,
            children:[
                {path:'',component:model},
                {path:'/model',component:model}
            ]
        },
        { 
            path: '/case' , 
            component: myCase ,
            children: [
                { path: '', component: CaseSix },
                { path: 'Case713', component: Case713 },
                { path: 'Case713dz', component: Case713dz },
                { path: 'CaseHT', component: CaseHT },
                { path: 'CaseSix', component: CaseSix },
                { path: 'CaseZJLY70', component: CaseZJLY70 },
                { path: 'Case38', component: Case38 },
                { path: 'CaseDIY', component: CaseDIY },
            ]
        },
        {
            path:'/team',
            component:MyTeam,
            children:[
                {path:'',component:Introduction},
                {path:'Introduction',component:Introduction},
                {path:'Activity',component:Activity},
                {path:'Training',component:Training}
            ]
        },
        {
            path:'/management',
            component:management,
            children:[
                {path:'',component:sixs},
                {path:'/sixs',component:sixs},
                {path:'/informatization',component:informatization},
                {path:'/nutrition',component:nutrition},
                {path:'/pdca',component:pdca},
                {path:'/safe',component:safe},
                {path:'/system',component:system}
            ]
        },
        { 
            path: '/gy', 
            component: MyGy , 
            children: [
                { path: '', component: MyGy1 },
                { path: 'gy1', component: MyGy1 },
                { path: 'gy2', component: MyGy2 },
            ]
        },
        { path: '/login', component: login },
        { 
            path: '/myht' , 
            component: MyHt ,
            redirect: "/layout",
            children: [
                // { path: '', component: MyCggl },
                // { 
                //     path: 'cggl' , 
                //     component: MyCggl,
                //     children: [
                //         { path: '', component: MyCg1 },
                //         { path: 'cg1', component: MyCg1 },
                //     ]
                
                // },
                {
                    path:'/layout',
                    component:layout,
                    redirect:"/article",
                    children:[
                        {
                            path:'/article',
                            component:article
                        },
                        {
                            path:'/articleWangedit',
                            component:articleWangedit
                        }
                    ]
                }
                
            ]
        
        }
        
    ]
    const router = new VueRouter({
        // mode: 'history',
        base: process.env.BASE_URL,
        routes
      })

// 全局前置守卫
router.beforeEach(function(to, from, next) {
    if (pathArr.indexOf(to.path) !== -1) {
      const token = localStorage.getItem('token')
      if (token) {
        next()
      } else {
        next('/login')
      }
    } else {
      next()
    }
  })



//
// // 全局路由守卫
// router.beforeEach((to,from,next)=>{
//     // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
//     if(to.fullPath !== "/login"){
//       //登录认证
//       let token = JSON.parse(localStorage.getItem('token'))
//       // 获取本地存储的userInfo
      
//       //获取本地存储的activeRouter
//       //如果token不存在,提示信息,并且返回登录页
//       if (token === null || token === '') {
//         Message({
//           showClose:true,
//           message:'请先登录后再访问!',
//           type:'error'
//         })
//           next("/login")
//         return
//       }
//     }
//     //如果在登录页,则继续操作
//     next()
//   })

//向外共享路由对象
export default router